export var Feature;
(function (Feature) {
    Feature["saveToProfile"] = "saveToProfile";
})(Feature || (Feature = {}));
//# sourceMappingURL=Feature.js.map